import { Controller } from "@hotwired/stimulus"

const STORAGE_KEY = "tree:expanded"

export default class extends Controller {
  connect() {
    this.expandedIds.forEach((id) => this.expand(id))
  }

  toggle(event) {
    event.stopPropagation()
    const id = event.currentTarget.dataset.childrenId
    const children = document.getElementById(id)
    if (!children) return

    const nowHidden = children.classList.toggle('hidden')
    event.currentTarget.querySelector('.tree-arrow')
      ?.classList.toggle('rotate-90', !nowHidden)

    this.persist(id, !nowHidden)
  }

  expand(id) {
    const children = document.getElementById(id)
    if (!children) return

    children.classList.remove('hidden')
    this.element.querySelector(`[data-children-id="${id}"] .tree-arrow`)
      ?.classList.add('rotate-90')
  }

  get expandedIds() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []
    } catch {
      return []
    }
  }

  persist(id, expanded) {
    const ids = new Set(this.expandedIds)
    expanded ? ids.add(id) : ids.delete(id)
    localStorage.setItem(STORAGE_KEY, JSON.stringify([...ids]))
  }
}
